import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { ApiCourseRequest } from "data/queries/ApiCourse";
import { useEffect, useState } from "react";

export const QUERY = print(gql`
  query TeachingAreas {
    TeachingAreas(perPage: -1, active: true) {
      items {
        name
        id
      }
    }
  }
`);

export interface QueryGql {
  TeachingAreas: {
    items: Array<{
      id: number;
      name: string;
    }>;
  };
}

export default function useTeachingAreas() {
  const [teachingAreas, setTeachingAreas] = useState<null | QueryGql["TeachingAreas"]["items"]>(
    null
  );

  useEffect(() => {
    ApiCourseRequest<QueryGql>({
      query: QUERY,
    }).then(({ data }) => setTeachingAreas(data.data.TeachingAreas.items));
  }, []);

  return {
    teachingAreas,
  };
}
